import React from "react";
import "./IndustryConnect.css";

const IndustryConnect = () => {
    const points = [
        {
            number: "01",
            title: "Industry Insights",
            description:
                "Understand current software industry practices, technologies and workplace expectations.",
            icon: "💡",
        },
        {
            number: "02",
            title: "Career Guidance",
            description:
                "Learn about career opportunities, required skills and how to prepare for professional roles.",
            icon: "🎯",
        },
        {
            number: "03",
            title: "Real-World Expectations",
            description:
                "Gain practical insights into how development teams work and what companies expect from freshers.",
            icon: "💼",
        },
        {
            number: "04",
            title: "Professional Exposure",
            description:
                "Interact with industry professionals and learn from their experience and practical knowledge.",
            icon: "🤝",
        },
    ];

    return (
        <section className="industry-connect-section">

            {/* ================= HEADER ================= */}

            <div className="industry-connect-header">

                <span className="industry-connect-badge">
                    INDUSTRY CONNECT
                </span>

                <h2>
                    Connect With Industry.
                    <span> Learn From Experience.</span>
                </h2>

                <p>
                    Students get exposure to industry perspectives through
                    expert sessions, career discussions and practical insights
                    that help them understand the expectations of the software
                    industry.
                </p>

            </div>


            {/* ================= MAIN CONTENT ================= */}

            <div className="industry-connect-content">

                {/* ================= VIDEO ================= */}

                <div className="industry-connect-video-card">

                    <div className="industry-video-wrapper">

                        <video
                            src="/videos/IndustryConnect.mp4"
                            className="industry-connect-video"
                            autoPlay
                            muted
                            loop
                            playsInline
                            preload="auto"
                            disablePictureInPicture
                            controlsList="nodownload nofullscreen noremoteplayback"
                        >
                            Your browser does not support the video tag.
                        </video>

                        <div className="industry-video-overlay">

                            <span>
                                PRT ACADEMY
                            </span>

                            <h3>
                                Industry Connect Session
                            </h3>

                        </div>

                    </div>

                </div>


                {/* ================= POINTS ================= */}

                <div className="industry-connect-points">

                    {points.map((point) => (

                        <article
                            className="industry-connect-point"
                            key={point.number}
                        >

                            <div className="industry-point-top">

                                <div className="industry-point-icon">
                                    {point.icon}
                                </div>

                                <span className="industry-point-number">
                                    {point.number}
                                </span>

                            </div>

                            <h3>
                                {point.title}
                            </h3>

                            <p>
                                {point.description}
                            </p>

                        </article>

                    ))}

                </div>

            </div>


            {/* ================= BOTTOM MESSAGE ================= */}

            <div className="industry-connect-bottom">

                <div>

                    <span>
                        LEARN • CONNECT • GROW
                    </span>

                    <h3>
                        Understand the Industry
                        <strong> Before You Enter It.</strong>
                    </h3>

                </div>

                <p>
                    Industry exposure helps students connect their classroom
                    learning with real professional expectations.
                </p>

            </div>

        </section>
    );
};

export default IndustryConnect;